/**
 * 貸出時間のリストを作成する
 * @param {number} min 開始時刻 (100h + m; 10時なら1000)
 * @param {number} max 終了時刻 (100h + m; 18:30なら1830)
 * @param {number} interval 時間の間隔 [min]
 * @return {array<string>}
 */
function createTimeList (min, max, interval) {
	const values = []
	const addT = (x, y) => {
		let hour = Math.floor(x / 100) + Math.floor(y / 100)
		let min = (x % 100) + (y % 100)
		while (min >= 60) {
			hour += 1
			min -= 60
		}
		return hour * 100 + min
	}
	const format = (t) => `${Math.floor(t / 100)}:${String(t % 100).padStart(2, '0')}`
	for (let t = min; t <= max; t = addT(t, interval)) {
		values.push(format(t))
	}
	return values
}

export default {
	name: 'TimeSelect',
	props: {
		value: String
	},
	data () {
		/**
		 * 指定できる貸出時間のリスト
		 * @var {array<string>}
		 */
		const timeList = createTimeList(900, 1900, 30)

		return {
			val: this.value,
			timeList
		}
	},
	template: `
		<select class="m-sch__select"
			v-model="val"
			@change="fireInput"
			@click="$emit('controlClick')"
		>
			<option v-for="time in timeList" :key="time"
				:value="time"
			>
				{{ time }}
			</option>
		</select>
	`,
	methods: {
		fireInput () {
			this.$emit('input', this.val)
		}
	},
	watch: {
		value () {
			this.val = this.value
		}
	}
}
